import { siteInfo } from '@/mocks/homeData';

const footerLinks = [
  {
    title: '热门导航',
    links: [
      { label: '热点爆料', href: '#cards' },
      { label: '最新快讯', href: '#updates' },
      { label: '热门话题', href: '#topics' },
      { label: '视频专区', href: '#media' },
    ],
  },
  {
    title: '常用入口',
    links: [
      { label: '吃瓜指南', href: '#faq' },
      { label: '专题合集', href: '#index' },
      { label: '吃瓜热度榜', href: '#ranking' },
      { label: '焦点专题', href: '#carousel' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '移动客户端', href: '#app' },
      { label: '网友热议', href: '#comments' },
    ],
  },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2">
            <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="inline-block font-heading text-xl font-bold text-background-50 mb-3 cursor-pointer">
              {siteInfo.name}
            </a>
            <p className="text-sm leading-relaxed text-background-50/50 max-w-xs">
              国内领先的娱乐八卦与热点事件聚合平台，每日更新最新黑料吃瓜在线观看资源，覆盖明星八卦、社会事件、网络爆料等领域。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-medium text-background-50 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-6 mb-6">
          <h4 className="text-sm font-medium text-background-50 mb-3">合作伙伴</h4>
          <p className="text-xs text-background-50/30">战略合作伙伴招募中，期待与优质内容平台携手共进</p>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>黑料吃瓜在线观看</span>
            <span className="text-background-50/20">|</span>
            <span>黑料吃瓜在线播放</span>
            <span className="text-background-50/20">|</span>
            <span>黑料吃瓜在线视频</span>
          </div>
        </div>
      </div>
    </footer>
  );
}